import axios from "../../utils/axiosInstance";

export function updatePurgeHistoryGridUseFilterStateReactive(useFilterState) {
    return axios.post("/updatePurgeHistoryGridUseFilterStateReactive", {newUseFilterState: useFilterState})
}

export function updatePurgeHistoryGridFilterModelReactive(newFilterModel) {
    return axios.post("/updatePurgeHistoryGridFilterModelReactive", {newFilterModel})
}

export function updatePurgeHistoryGridUseColumnStateReactive(useColumnState) {
    return axios.post("/updatePurgeHistoryGridUseColumnStateReactive", {newUseColumnState: useColumnState})
}

export function updatePurgeHistoryGridColumnStateReactive(columnStatesList) {
    return axios.post("/updatePurgeHistoryGridColumnStateReactive", {columnStatesList})
}

export function updatePurgeHistoryGridColumnModeReactive(columnMode) {
    return axios.post("/updatePurgeHistoryGridColumnModeReactive", {columnMode})
}

export async function getPurgeHistoryGridFilterStateReactive() {
    const response = await axios.post("/getPurgeHistoryGridFilterStateReactive")
    return response.data
}

export async function getPurgeHistoryGridColumnStateReactive() {
    const response = await axios.post("/getPurgeHistoryGridColumnStateReactive")
    return response.data
}

export const purgeGroup = async (zenGroupId) => {
    return await axios.post("/ccPurgeGroup", {
        zenGroupId: zenGroupId
    })
}